<template>
    <div>
        <div class="faq-question" v-on:click="toggleExtend">
            <i v-if="extended" class="material-icons">remove_circle</i>
            <i v-else class="material-icons">add_circle</i>
            <h4>{{faq.faq_question}}</h4>
        </div>
        <div v-if="extended" class="faq-answer">
            <vue-simple-markdown :source=faq.faq_answer></vue-simple-markdown>
        </div>
    </div>
</template>

<script>
export default {
    name: "Faqcordion",
    props: {
        faq: Object,
        // extended: Boolean
    },
    data() {
        return {
            extended: false,
        }
    },

    methods: {
        toggleExtend() {
            if (this.extended == false){
                this.extended = true;
            }
            else{
                this.extended = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.faq-question, .faq-answer{
    padding: 4px 8px;
    /*border-radius: 10px;*/
    color: 182E5A;
    border: 1px solid #eeeeee;


}


.faq-question{
    
    display: flex;
    flex-direction: row;
    margin-top: 8px;
    /*border-radius: 10px;
    background-color: #395597;
    color: #eeeeee;*/
    

    

    i{
        margin-right: 8px;
    }   

    h4{
        margin: 0;
    }

    &:hover{
        cursor: pointer;
    }
}

.faq-answer {
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: 32px;
    padding-right: 32px;

    .markdown-body{
        font-size: 18px;
    }
    
}

.faq-question {
    padding: 8px;
}

</style>